const topics = [
  { id: 1, name: '#明星塌房', heat: '1280万讨论', trending: true },
  { id: 2, name: '#直播翻车', heat: '960万讨论', trending: true },
  { id: 3, name: '#网红互撕', heat: '890万讨论', trending: true },
  { id: 4, name: '#综艺名场面', heat: '750万讨论', trending: false },
  { id: 5, name: '#品牌解约潮', heat: '680万讨论', trending: false },
  { id: 6, name: '#选秀黑幕', heat: '620万讨论', trending: false },
  { id: 7, name: '#恋情实锤', heat: '580万讨论', trending: false },
  { id: 8, name: '#学历造假', heat: '520万讨论', trending: false },
  { id: 9, name: '#职场爆料', heat: '460万讨论', trending: false },
  { id: 10, name: '#体育圈大瓜', heat: '410万讨论', trending: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">全网吃瓜热点话题一网打尽，跟进最新讨论动态</p>
        </div>

        <div className="flex flex-wrap gap-2 md:gap-3">
          {topics.map((topic) => (
            <div
              key={topic.id}
              className={`group inline-flex items-center gap-2 px-3 md:px-4 py-2 md:py-2.5 rounded-full border transition-all duration-200 cursor-pointer ${
                topic.trending
                  ? 'bg-accent-50 border-accent-300 hover:bg-accent-100'
                  : 'bg-background-50 border-background-200 hover:border-secondary-300 hover:bg-secondary-50'
              }`}
            >
              {topic.trending && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse flex-shrink-0"></span>
              )}
              <span className={`text-sm font-medium whitespace-nowrap ${
                topic.trending ? 'text-accent-700' : 'text-foreground-700'
              }`}>
                {topic.name}
              </span>
              <span className="text-[11px] text-foreground-400 whitespace-nowrap">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}